/**
 * Constants for session management
 */

/**
 * Maximum number of sessions to display in UI components (upcoming and recently completed)
 */
export const MAX_DISPLAYED_SESSIONS = 5;